import UltMeta, { Meta } from "./UltMeta/index";

class State extends UltMeta {
    DISABLED = new Meta(0, "禁用");
    ENABLE = new Meta(1, "启用");
}
export const STATE = new State();

class MonitorBehavior extends UltMeta {
    ENTERAREA = new Meta(1, "进入");
    LEAVEAREA = new Meta(2, "离开");
}
export const MONITOR_BEHAVIOR = new MonitorBehavior();

class FenceReminderRecordsMonitorBehavior extends UltMeta {
    ENTERAREA = new Meta(1, "进入标记区域");
    LEAVEAREA = new Meta(2, "离开标记区域");
}
export const FENCE_REMINDER_RECORDS_MONITOR_BEHAVIOR = new FenceReminderRecordsMonitorBehavior();

class IsWechatReminder extends UltMeta {
    NO = new Meta(0, "否");
    YES = new Meta(1, "是");
}
export const IS_WECHAT_REMINDER = new IsWechatReminder();

class ActualStatus extends UltMeta {
    EMPTY_SHIP = new Meta(1, "空船，待订货");
    UNLOADING_AT_PORT = new Meta(2, "靠港，卸货中");
    LOADING_AT_PORT = new Meta(3, "靠港，装货中");
    WAITING_UNLOAD_ON_WATER = new Meta(4, "上水，待卸货");
    WAITING_LOAD_ON_WATER = new Meta(5, "上水，待装货");
    WAITING_UNLOAD_DOWN_WATER = new Meta(6, "下水，待卸货");
    WAITING_LOAD_DOWN_WATER = new Meta(7, "下水，待装货");
    WAITING_UNLOAD_DETENTION = new Meta(8, "滞港，待卸货");
    WAITING_LOAD_DETENTION = new Meta(9, "滞港，待装货");
}


export const ACTUAL_STATUS = new ActualStatus();

class ProcessStatus extends UltMeta {
    UNPROCESSED = new Meta(1, "未处理");
    FOLLOWING_UP = new Meta(2, "持续跟进");
    PROCESSED = new Meta(3, "已处理完成");
}
export const PROCESS_STATUS = new ProcessStatus();
